import { render, staticRenderFns } from "./Accountant.vue?vue&type=template&id=2a435947&scoped=true"
import script from "./Accountant.vue?vue&type=script&lang=js"
export * from "./Accountant.vue?vue&type=script&lang=js"
import style0 from "./Accountant.vue?vue&type=style&index=0&id=2a435947&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a435947",
  null
  
)

export default component.exports